<template>
    <div class="add">
        <div class="top-box">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>加盟商管理</el-breadcrumb-item>
                <el-breadcrumb-item>新增加盟商</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="tab-list d_flex a_c ">
                <h2>新增加盟商</h2>
                <div class="item" @click="toList">加盟商列表</div>
            </div>
        </div>
        <div class="page-content">
            <div class="add-box">
                <el-form ref="form" :rules="rules" :model="form" label-width="100px" align="left" >
                    <el-form-item label="用户名" prop="username" style="width: 350px;">
                        <el-input v-model="form.username" autocomplete="off"  placeholder="请输入昵称"></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="password" style="width: 350px;">
                        <el-input placeholder="请输入登录密码"  autocomplete="off" auto-complete="new-password" v-model="form.password" show-password></el-input>
                    </el-form-item>
                    <el-form-item label="真实姓名" prop="realname" style="width: 350px;">
                        <el-input v-model="form.realname" placeholder="请输入真实姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="联系人电话"  prop="mobile" style="width: 350px;">
                        <el-input v-model="form.mobile" maxlength="11" placeholder="请输入联系人电话"></el-input>
                    </el-form-item>
                    <el-form-item label="用户角色" prop="role_id">
                        <el-select v-model="form.role_id" placeholder="请选择角色" @change="changeRole">
                            <el-option :label="item.role_name" :value="item.role_id" v-for="item in roleList" :key="item.role_id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="isShowType">
                        <el-checkbox-group v-model="form.checkList">
                            <el-checkbox :label="item.cate_id" v-for="item in roleType"  :key="item.cate_id">{{item.name}}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item v-if="isQx">
                        <el-tree
                                ref="tree"
                                :data="Qxlist"
                                show-checkbox
                                node-key="id"
                                :props="defaultProps"
                                v-model="form.treeList"
                        >
                        </el-tree>
                    </el-form-item>
                    <el-form-item label="所属城市" prop="city_id" v-if="role_id==1">
                        <el-select v-model="form.city_id" filterable placeholder="输入城市关键字">
                            <el-option
                                    v-for="item in cityList"
                                    :key="item.city_id"
                                    :label="item.name"
                                    :value="item.city_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属城市" v-else style="width: 350px;">
                        <el-input v-model="form.city_name" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">立即添加</el-button>
                        <el-button  @click="toList">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import {getRoleList,roleList} from '../../api/role'
    import {searchCity} from '../../api/city'
    import {addBusiness,spaceType} from '../../api/agency'

    export default {
        name: "add",
        data(){
            var checkPhone = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('手机号码不能为空'));
                }
                setTimeout(() => {
                    if (!/^[1][0-9]{10}$/.test(value)) {
                        callback(new Error('请输入正确的手机号码'));
                    } else {
                        callback();
                    }
                }, 500);
            };
            return{
                form: {
                    username: '',
                    password: '',
                    realname: '',
                    mobile: '',
                    role_id: '',
                    checkList:[],
                    proxy_type_ids:'',
                    city:'',
                    city_id:'',
                    city_name:'',
                    treeList:[],
                    access_ids:'',
                },

                roleList:[],
                cityList:[],
                roleType:[],//二级代理类型
                isShowType:false,//二级代理选择
                isQx:false,//权限控制
                Qxlist:[],
                defaultProps: {
                    children: 'child',
                    label: 'cname'
                },
                role_id:0,
                userinfo:'',
                rules:{
                    username: [
                        { required: true, message: '请输入用户名', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' }
                    ],
                    realname: [
                        { required: true, message: '请输入真实姓名', trigger: 'blur' }
                    ],
                    mobile: [
                        { required: true, message: '请输入手机号码', trigger: 'blur' },
                        { validator: checkPhone, trigger: 'blur' }
                    ],
                    role_id: [
                        { required: true, message: '请选择用户角色', trigger: 'blur' }
                    ],
                    city_id: [
                        { required: true, message: '请选择城市', trigger: 'blur' }
                    ],
                }
            }
        },
        mounted(){
            this.role_id=localStorage.getItem('ROLE');
            this.userinfo=JSON.parse(localStorage.getItem('USERINFO'));
            if(this.role_id!=1){
                this.form.city_id=this.userinfo.city_id;
                this.form.city_name=this.userinfo.city_name;
            }
            this.getRoleList();
            this.searchCity();
            this.spaceType();
            this.getQxlist();
        },
        methods:{
            changeRole(e){
                if(e==3){
                    this.isShowType=true;
                }else if(e==4){
                    this.isQx=true;
                }else{
                    this.isShowType=false;
                    this.isQx=false;
                }
            },
            getQxlist(){
                roleList().then(res=>{
                    if(res.code==1){
                        this.Qxlist=res.data;
                    }
                })
            },
            getRoleList(){
                getRoleList().then(res=>{
                    if(res.code==1){
                        this.roleList=res.data;
                        if(this.role_id==1){
                            this.roleList.splice(0,1);
                            this.roleList.pop();
                            this.roleList.pop();
                        }else if(this.role_id==2){
                            this.roleList.shift();
                            this.roleList.shift();
                            this.roleList.pop();
                        }else if(this.role_id==3){
                            this.roleList.splice(0,2);
                            this.roleList.pop();
                        }
                    }
                })
            },
            searchCity(){
                searchCity({level:2}).then(res=>{
                    if(res.code==1){
                        console.log(res);
                        this.cityList=res.data;
                    }
                })
            },
            spaceType(){
                spaceType().then(res=>{
                    if(res.code==1){
                        this.roleType=res.data;

                    }
                })
            },

            toList(){
                this.$router.push({path: '/alliance/alliance'});
            },
            onSubmit() {
                this.form.proxy_type_ids=this.form.checkList.join(',');
                console.log(this.form);
                let ids=[],ads=[];
                if(this.form.role_id==4){
                    let arr=this.$refs.tree.getCheckedNodes();
                    arr.map(val=>{
                        if(val.fid!=0){
                            ids.push(val.id);
                        }else{
                            ads.push(val.id)
                        }
                    })
                    this.form.role_adm_access_ids=ids.join(',')
                    this.form.role_adm_id=ads.join(',')
                }
                addBusiness(this.form).then(res=>{
                    if(res.code==1){
                        this.$message({
                            type: 'success',
                            message: '新增成功!'
                        });
                        this.toList();
                    }else{
                        this.$message({
                            type: 'warning',
                            message: res.msg
                        });
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .top-box{
        width: 100%;
        height: 100px;
        background-color: #ffffff;
        padding: 20px;
        .tab-list{
            margin-top: 20px;
            h2{
                margin-right: 20px;
                padding-right: 20px;
                border-right: 1px solid #eaeaea;
            }
            .item{
                font-size: 16px;
                color: #409EFF;
                display: flex;
                align-items: center;
                cursor: pointer;
                .icon{
                    font-size: 20px;
                    color: #409EFF;
                    margin-right: 5px;
                }
            }
        }

    }
    .page-content{
        padding: 20px;
        .add-box{
            background-color: #fff;
            padding: 30px;
        }
    }

</style>
